import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import { token } from '@atlaskit/tokens';

import { wacToken } from '@/libraries/design/foundations';

export const SkipToContent = () => {
	const intl = useIntl();

	const skipToContentStyles = css({
		position: 'absolute',
		zIndex: 999,
		marginBlockStart: token('space.025'),
		paddingInline: token('space.200'),
		paddingBlock: '10px',
		backgroundColor: wacToken('color.neutral.light0'),
		color: wacToken('color.primary.black'),
		insetBlockStart: '100%',
		insetInlineStart: '-9999px', // Moves the link off-screen to the left, making it invisible, but still focus-able

		':focus': {
			insetInlineStart: 'auto',
		},
	});

	return (
		<a
			href="#content"
			className="skip-to-content"
			css={skipToContentStyles}
			data-testid="skip-to-content"
			// needed so that the link is the first thing tabbed, but still positioned correctly
			// eslint-disable-next-line jsx-a11y/tabindex-no-positive
			tabIndex={1}
		>
			{intl.formatMessage({
				id: 'nav.skipToContent',
				defaultMessage: 'Skip to content',
			})}
		</a>
	);
};
